export default __webpack_public_path__ + "static/media/Cover (4) 2.29701321.png";